import * as actions from './actions';
import reducers from './reducer';

export const Error = { actions, reducers };
export { ErrorState } from './reducer';
